<template>
  <!-- Loading -->
  <div class="vld-parent">
    <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
  </div>

  <div class="booking-full-container">
    <div class="booking-data-container" style="background-color: white;">
      <FullCalendar :options='calendarOptions' />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import { ref, reactive, onMounted, computed, watchEffect } from 'vue'
import { useRouter } from 'vue-router'
import { useToast } from 'vue-toastification'
import Loading from 'vue-loading-overlay'

import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'

export default {
  components: {
    FullCalendar,
    Loading
  },
  props: {
    propObject: {
      type: Object,
      default: () => ({ empty: true })
    }
  },
  data: function () {
    return {}
  },
  emits: ['close-modal', 'submit', 'refresh-list'],
  setup (props, { emit }) {
    const presenceData = reactive([])
    const isLoading = ref(false)
    const toast = useToast()
    const router = useRouter()

    const userlogin = localStorage.getItem('name')
    const employee = reactive({})

    onMounted(() => {
    })

    const filterData = (start, end) => {
      isLoading.value = true
      const params = reactive({
        id: employee.id,
        work_unit_id: employee.work_unit_id,
        start: start,
        end: end
      })
      console.log('cek get presence', params)

      axios
        .get('presenceemployee-calendar', {
          params
        })
        .then((response) => {
          // assign state kelass with response data
          isLoading.value = false
          presenceData.value = response.data.data
          console.log("cek dat calendar", presenceData.value)
        })
        .catch((error) => {
          isLoading.value = false
          console.log(error)
        })
    }

    const fetchEventsForMonth = (start, end) => {
      if (employee && employee.id && employee.id !== '') {
        filterData(start, end)
      }
    }

    const calendarOptions = computed(() => ({
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin],
      themeSystem: 'bootstrap5',
      selectable: true,
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth'
      },
      eventMouseEnter: function (info) {
        const tooltip = document.createElement('div')
        tooltip.innerText = info.event.extendedProps.description || info.event.title
        tooltip.style.position = 'absolute'
        tooltip.style.background = '#333'
        tooltip.style.color = '#fff'
        tooltip.style.padding = '5px 10px'
        tooltip.style.borderRadius = '4px'
        tooltip.style.fontSize = '12px'
        tooltip.style.zIndex = '1000'
        tooltip.classList.add('fc-tooltip')
        document.body.appendChild(tooltip)

        info.el.addEventListener('mousemove', function (e) {
          tooltip.style.top = e.pageY + 10 + 'px'
          tooltip.style.left = e.pageX + 10 + 'px'
        })

        info.el._tooltip = tooltip
      },
      eventMouseLeave: function (info) {
        if (info.el._tooltip) {
          document.body.removeChild(info.el._tooltip)
          delete info.el._tooltip
        }
      },
      datesSet: (info) => {
        fetchEventsForMonth(info.startStr, info.endStr)
      },
      events: presenceData.value
    }))

    watchEffect(() => {
      const newobject = props.propObject
      Object.assign(employee, newobject)
      console.log('employeeCalendar', employee)
    })

    return {
      employee,
      presenceData,
      filterData,
      calendarOptions,
      fetchEventsForMonth,
      router,
      toast,
      userlogin,
      isLoading
    }
  }
}
</script>
